import React, { Component } from "react";
import { Redirect } from "react-router";
import { isAuthenticated } from "../../ui/src/modules/AuthenticationProvider";

//import "./AppShell.css";


export class AppShell extends Component {
  render() {
    if (!isAuthenticated()) {
      return <Redirect to="/Login" />;
    }

    return (
      <div className="appShell">
        <div className="appMenuWrapper">{this.props.appMenu}</div>
        <div className="appContentWrapper">{this.props.children}</div>
      </div>
    );
  }
}